import React from "react";

export default function RaceTo17({ data }) {
  const { casinoIndividualResultDTO } = data || {};
  const { casinoIndividualResultMaps, casinoCardResultMaps } =
    casinoIndividualResultDTO || {};

  // Extract match details
  const matchTime = new Date(
    casinoIndividualResultDTO?.createdAt + "Z"
  ).toLocaleString();
  const roundId = casinoIndividualResultDTO?.marketId;

  // Extract winner, points, and cards
  const raceTo17 = casinoIndividualResultMaps?.find(
    (item) => item.resultFor === "Race to 17"
  )?.result[0];

  const bigCard = casinoIndividualResultMaps?.find(
    (item) => item.resultFor === "Big Card"
  )?.result[0];

  const zeroCard = casinoIndividualResultMaps?.find(
    (item) => item.resultFor === "Zero Card"
  )?.result[0];

  const oneZeroCard = casinoIndividualResultMaps?.find(
    (item) => item.resultFor === "One Zero Card"
  )?.result[0];


  const winner = raceTo17;

  // Map suits to their respective icons
  const suits = {
    Spade:
      "https://versionobj.ecoassetsservice.com/v24/static/front/img/icons/spade.png",
    Heart:
      "https://versionobj.ecoassetsservice.com/v24/static/front/img/icons/heart.png",
    Club:
      "https://versionobj.ecoassetsservice.com/v24/static/front/img/icons/club.png",
    Diamond:
      "https://versionobj.ecoassetsservice.com/v24/static/front/img/icons/diamond.png",
  };

  return (
    <div className="modal-content">
      <div className="modal-body">
        <div className="casino-result-modal">
          <div className="casino-result-round-id">
            <span>
              <b>Round Id: </b> {roundId}
            </span>
            <span>
              <b>Match Time: </b> {matchTime}
            </span>
          </div>
          <div className="race-result-box">
            {/* Render cards for each suit */}
            {casinoCardResultMaps?.map((suitData, index) => (
              <div className="casino-result-cards" key={index}>
                <img
                  src={suits[suitData.resultFor]}
                  alt={suitData.resultFor}
                />
                {suitData.result.map(
                  (card, cardIndex) =>
                    card !== "1" && (
                      <img
                        key={cardIndex}
                        src={`https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/${card}.png`}
                        alt={card}
                      />
                    )
                )}
               
                {winner === suitData.resultFor && (
                  <div className="casino-winner-icon">
                    <i className="fas fa-trophy" />
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="row mt-2 justify-content-center">
            <div className="col-md-6">
              <div className="casino-result-desc">
                <div className="casino-result-desc-item">
                  <div>Race To 17 </div>
                  <div>{raceTo17}</div>
                </div>
                <div className="casino-result-desc-item">
                  <div>Big Card</div>
                  <div>{bigCard}</div>
                </div>
                <div className="casino-result-desc-item">
                  <div>Zero Card</div>
                  <div>{zeroCard}</div>
                </div>
                <div className="casino-result-desc-item">
                  <div>One Zero Card</div>
                  <div>{oneZeroCard}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
